require.register("import/controllers/newCtrl", function(exports, require, module){
  $0
  
});

